import { UrlMatchResult, UrlSegment } from '@angular/router';

export function faqProductsCategoryMatcher(segment: UrlSegment[]): UrlMatchResult {
  if (
    segment.length > 2 &&
    segment[0].path === 'faq' &&
    segment[segment.length - 2].path === 'csc' &&
    segment[segment.length - 1].path !== 'products'
  ) {
    return { consumed: segment, posParams: { categoryCode: segment[segment.length - 1] } };
  }
  return null;
}
